import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'genderSymbolHtml',
  standalone: false
})
export class GenderSymbolHtmlPipe implements PipeTransform {
  transform(value: unknown, femaleSymbol = 'F', maleSymbol = 'M'): string {
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    value = value?.toString();
    let icon = 'question';

    switch (value) {
      case femaleSymbol:
        icon = 'venus';
        break;
      case maleSymbol:
        icon = 'mars';
        break;
      default:
        icon = 'mars-and-venus';
    }

    return `<span class="fa fa-${icon} fa-lg"></span>`;
  }
}
